export const ContentPosition = {
    MIDDLE: "MIDDLE",
    MIDDLE50: "MIDDLE50",
    MIDDLELEFT: "MIDDLELEFT",
    MIDDLELEFT40: "MIDDLELEFT40",
    MIDDLEBOTTOM: "MIDDLEBOTTOM"
}